module.exports = __webpack_public_path__ + "media/credit_request.fc6b1986.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/cloud/credit/credit_request.png
// module id = 756
// module chunks = 2